<template>
  <figure class="mockup">
    <div class="mockup__container">
      <div class="mockup__taskbar">
        <span class="mockup__taskbar-button" />
        <span class="mockup__taskbar-button" />
        <span class="mockup__taskbar-button" />
      </div>

      <div class="mockup__body">
        <div class="mockup__banner">VOTRE SITE</div>

        <div class="mockup__row">
          <div class="mockup__col">
            <div class="mockup__line" />
            <div class="mockup__line" />
            <div class="mockup__line" />
          </div>

          <div class="mockup__col mockup__block" />
        </div>

        <div class="mockup__row">
          <div class="mockup__col" />

          <div class="mockup__col -row">
            <div class="mockup__block" />
            <div class="mockup__block" />
          </div>
        </div>
      </div>
    </div>
    <div class="mockup__badge__container">
      <Image
        v-if="$beet.options.general?.partner"
        class="mockup__badge"
        :source="$beet.options.general.partner"
      />
      <Image
        v-if="$beet.options.general?.expert"
        class="mockup__badge"
        :source="$beet.options.general.expert"
      />
    </div>
  </figure>
</template>

<script>
import Image from '@/components/global/Image.vue'

export default {
  name: 'Mockup',
  components: { Image },
}
</script>
